import { GlowOrb } from './NavBar';
import { scenarioImages } from '../images';

export function ScenarioSection() {
  const scenarios = [
    {
      image: scenarioImages.scenarioWarehouse,
      title: '智慧仓储',
      desc: '自主巡检货架状态，实时盘点库存，识别异常堆放与安全隐患。',
      tags: ['库存盘点', '安全巡检', '异常检测'],
    },
    {
      image: scenarioImages.scenarioSecurity,
      title: '安防巡逻',
      desc: '夜间自主巡逻园区 perimeter，识别入侵行为，联动无人机升空追踪。',
      tags: ['周界巡逻', '入侵识别', '无人机联动'],
    },
    {
      image: scenarioImages.scenarioConstruction,
      title: '工程巡检',
      desc: '深入施工现场危险区域，扫描结构变形，生成三维点云对比报告。',
      tags: ['结构扫描', '点云建模', '变形监测'],
    },
  ];

  return (
    <section id="场景" className="reveal relative py-24 overflow-hidden">
      <GlowOrb className="top-1/2 right-0 w-[400px] h-[400px] bg-accent-500/5" />
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <p className="text-xs font-mono tracking-[0.2em] text-primary-400 uppercase mb-3">Application Scenarios</p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-50 mb-4">覆盖核心产业场景</h2>
          <p className="text-base text-foreground-400 max-w-2xl">从仓储物流到安防巡检，从工程施工到应急救援，0xman 提供全场景的空间智能解决方案。</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {scenarios.map((s) => (
            <div key={s.title} className="card-glow rounded-2xl">
              <div className="group relative rounded-2xl overflow-visible border border-background-800/60 bg-background-900/40 hover:border-primary-500/30 transition-all">
                <div className="h-52 overflow-hidden rounded-t-2xl">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/40 to-transparent rounded-t-2xl" />
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-foreground-100 mb-2">{s.title}</h3>
                  <p className="text-sm text-foreground-400 leading-relaxed mb-4">{s.desc}</p>
                  <div className="flex flex-wrap gap-2">
                    {s.tags.map((tag) => (
                      <span key={tag} className="px-2.5 py-1 rounded-full bg-primary-500/10 text-[10px] text-primary-300 border border-primary-500/10">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TrustBadgesSection() {
  const badges = [
    { icon: 'ri-shield-check-line', label: 'ISO 27001', desc: '信息安全管理体系认证' },
    { icon: 'ri-award-line', label: '国家高新技术企业', desc: '科技部认定' },
    { icon: 'ri-stack-line', label: '等保三级', desc: '网络安全等级保护' },
    { icon: 'ri-global-line', label: 'CNAS 认证', desc: '实验室检测能力认可' },
    { icon: 'ri-robot-line', label: '50+ 核心专利', desc: '空间智能与具身智能领域' },
    { icon: 'ri-flashlight-line', label: '专精特新', desc: '北京市认定' },
  ];

  return (
    <section className="reveal relative py-16 overflow-hidden border-y border-background-800/40">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-10 text-center">
          <p className="text-xs font-mono tracking-[0.2em] text-primary-400 uppercase mb-2">Trust & Certifications</p>
          <h3 className="text-xl font-heading font-semibold text-foreground-200">行业资质与技术实力背书</h3>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {badges.map((b) => (
            <div key={b.label} className="flex flex-col items-center text-center p-4 rounded-xl border border-background-800/50 bg-background-900/30 hover:border-primary-500/25 transition-all">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 mb-3">
                <i className={`${b.icon} text-xl text-primary-400`} />
              </span>
              <p className="text-sm font-semibold text-foreground-200 mb-1">{b.label}</p>
              <p className="text-[11px] text-foreground-500">{b.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function PartnersSection() {
  const partners = [
    { name: '华航物流', abbr: '华航' },
    { name: '远景能源', abbr: '远景' },
    { name: '中铁十四局', abbr: '中铁' },
    { name: '海康智安', abbr: '海康' },
    { name: '华为云', abbr: '华为' },
    { name: '商汤科技', abbr: '商汤' },
    { name: '大疆创新', abbr: '大疆' },
    { name: '科大讯飞', abbr: '讯飞' },
  ];

  return (
    <section className="reveal relative py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-10 text-center">
          <p className="text-xs font-mono tracking-[0.2em] text-primary-400 uppercase mb-2">Strategic Partners</p>
          <h3 className="text-xl font-heading font-semibold text-foreground-200">信赖我们的合作伙伴</h3>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4">
          {partners.map((p) => (
            <div key={p.name} className="group flex items-center gap-3 px-5 py-3 rounded-xl border border-background-800/50 bg-background-900/30 hover:border-primary-500/25 transition-all">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 border border-background-700">
                <span className="text-xs font-bold text-foreground-400">{p.abbr}</span>
              </div>
              <span className="text-sm text-foreground-400 group-hover:text-foreground-200 transition-colors whitespace-nowrap">{p.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}